import { gql } from "graphql-tag";

export const LIST = gql`
query getListById($id: ID!) {
  interestList(id: $id) {
    id
    name
    isOpen
    defaultSorting
    waitTime
    property {
      id
      name
      respondToEmailEnabled
      timezone
      forms {
        id
        type
        open
        display
        createInterest
      }
    }
  }
}
`;
